import React, { ChangeEvent, useState, useEffect } from 'react';
import { ga } from '../../ga';
import ChatAddEmoji from './chat-add-emoji';

export default function ChatInput(props: {
  name: string;
  onInput: (message: { name: string; text: string }) => void;
  leaveChat: () => void;
}) {
  let messageInputRef = null;
  const [message, setMessage] = useState<string>('');
  const [err, setErr] = useState<string>('');
  const requestSendMessage = () => {
    setErr('');
    // Ensure we're not sending an empty message
    if (!message || message.trim() == '') return;

    try {
      props.onInput({
        name: props.name,
        text: message,
      });
      setMessage('');
      ga('send', 'event', 'chat', 'message', 'sent');
    } catch (e) {
      const rateLimitMatch: RegExpMatchArray = e.toString().match(/rate limit (\d{1,2})/i);
      if (rateLimitMatch) {
        setErr(
          `Slow down! Your chat has been rate limited. You can send another message in ${
            rateLimitMatch[1] || 30
          } seconds.`
        );
        ga('send', 'event', 'chat', 'rateLimit', 'warned');
      } else {
        setErr('Unknown error sending message. Please try again.');
        ga('send', 'event', 'chat', 'sendError', e.toString());
      }
    }
  };

  const addEmoji = (emoji) => {
    // if there is no text in the message don't put space before emoji, only after
    const emojiPlusSpace = `${emoji} `;
    const messageText = message.trim().length
      ? `${message.trim()} ${emojiPlusSpace}`
      : `${emojiPlusSpace}`;
    setMessage(messageText);
    messageInputRef.focus();
  };

  return (
    <div>
      <div>
        <span className="boxcast-chat--info">{props.name}</span>
        <span
          className="boxcast-chat--link boxcast-chat--edit-username"
          onClick={() => props.leaveChat()}
        >
          Leave Chat
        </span>
      </div>
      <form
        className="boxcast-chat--form"
        onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          requestSendMessage();
        }}
      >
        {err ? (
          <div className="boxcast-chat--error">
            {err}
            <a
              onClick={(e) => {
                e.preventDefault();
                setErr('');
              }}
            >
              Dismiss
            </a>
            .
          </div>
        ) : null}
        {err ? null : (
          <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                name="text"
                type="text"
                maxLength={200}
                ref={(c) => (messageInputRef = c)}
                autoComplete="off"
                placeholder="Say something..."
                value={message}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setMessage(e.target.value)}
                className="boxcast-chat--input"
              />
              <div>
                <ChatAddEmoji
                  toggleClasses="boxcast-chat--emoji-toggle"
                  pickerClasses="boxcast-chat--emojipicker"
                  onSelect={addEmoji}
                />
              </div>
            </div>
          </div>
        )}

        {err ? null : (
          <div className="boxcast-chat--send">
            <span>{message.length}/200</span>
            <button
              className="boxcast-chat--input-button"
              onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                e.preventDefault();
                requestSendMessage();
              }}
            >
              &nbsp;
            </button>
          </div>
        )}
      </form>
    </div>
  );
}
